"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGISTICS_TRACKING_NO_ERROR_MESSAGE = void 0;
exports.isBaseLogisticsTrackingNoValid = isBaseLogisticsTrackingNoValid;
exports.isLogisticsTrackingNoValid = isLogisticsTrackingNoValid;
exports.normalizeLogisticsTrackingNo = normalizeLogisticsTrackingNo;
exports.validateLogisticsTrackingNo = validateLogisticsTrackingNo;
var LOGISTICS_TRACKING_NO_ERROR_MESSAGE = exports.LOGISTICS_TRACKING_NO_ERROR_MESSAGE = '物流单号格式不正确，请输入 6-40 位数字、字母、横线或小数点';
var BASE_TRACKING_NO_PATTERN = /^[A-Z0-9.-]{6,40}$/;

// 按线上 eb_order_delivery 的高频物流公司和主流快递公司补充别名，
// 优先通过 deliveryCode 识别，拿不到 code 时再回退到 deliveryName。
var CODE_ALIAS_GROUPS = {
  sf: ['sf', 'shunfeng', 'shunfengkuaiyun'],
  jd: ['jd', 'jingdongkuaiyun'],
  zto: ['zhongtong', 'zto', 'zhongtongkuaiyun'],
  yto: ['yuantong', 'yto'],
  sto: ['shentong', 'sto'],
  yd: ['yunda', 'yd', 'yundakuaiyun'],
  jt: ['jtexpress', 'jtsd'],
  post: ['ems', 'youzhengguonei', 'youzhengbk', 'chinapost', 'youzhengguoji'],
  dbl: ['dbl', 'debangkuaidi'],
  htky: ['htky'],
  anneng: ['annengwuliu'],
  yimidida: ['yimidida'],
  danniao: ['danniao', 'cainiaozhisong']
};
var NAME_ALIAS_GROUPS = {
  sf: ['顺丰速运', '顺丰快运'],
  jd: ['京东物流', '京东快运'],
  zto: ['中通快递', '中通快运'],
  yto: ['圆通速递', '圆通快递'],
  sto: ['申通快递'],
  yd: ['韵达快递', '韵达速递', '韵达快运'],
  jt: ['极兔速递'],
  post: ['邮政快递包裹', '邮政EMS', 'EMS', '邮政标准快递', '国际包裹', '中国邮政（CHINA POST）'],
  dbl: ['德邦快递'],
  htky: ['百世快递'],
  anneng: ['安能快运'],
  yimidida: ['壹米滴答'],
  danniao: ['菜鸟速递']
};

// 规则设计说明：
// 1. 所有公司先走通用规则：允许数字、字母、横线、小数点，6-40 位，且不能纯字母。
// 2. 命中公司后再走差异化规则，尽量兼容线上已有单号前缀和主流快递常见格式。
// 3. 未命中公司的场景只走通用规则，避免误杀低频物流公司。
var COMPANY_RULES = {
  // 顺丰/顺丰快运：常见以 SF 开头，也兼容历史纯数字单号
  sf: /^(?:SF[A-Z0-9]{10,28}|\d{8,20})$/,
  // 京东物流/京东快运：常见 JD 开头，线上也有纯数字单号
  jd: /^(?:JD[A-Z0-9]{6,28}|\d{8,30})$/,
  // 中通/中通快运：兼容 ZTO 前缀与纯数字单号
  zto: /^(?:ZTO[A-Z0-9]{5,27}|\d{8,30})$/,
  // 圆通：兼容 YT 前缀与纯数字单号
  yto: /^(?:YT[A-Z0-9]{6,28}|\d{8,30})$/,
  // 申通：兼容 STO 前缀与纯数字单号
  sto: /^(?:STO[A-Z0-9]{5,27}|\d{8,30})$/,
  // 韵达/韵达快运：兼容 YD 前缀与纯数字单号
  yd: /^(?:YD[A-Z0-9]{6,28}|\d{8,30})$/,
  // 极兔：兼容 JT 前缀与纯数字单号
  jt: /^(?:JT[A-Z0-9]{6,28}|\d{8,30})$/,
  // EMS/邮政：兼容国际常见的 2字母+9数字+2字母 和国内纯数字单号
  post: /^(?:[A-Z]{2}\d{9}[A-Z]{2}|\d{8,30})$/,
  // 德邦：兼容 DPK/DBL 前缀与纯数字单号
  dbl: /^(?:DPK[A-Z0-9]{5,27}|DBL[A-Z0-9]{5,27}|\d{8,30})$/,
  // 百世：兼容 HTKY 前缀与纯数字单号
  htky: /^(?:HTKY[A-Z0-9]{4,26}|\d{8,30})$/,
  // 以下几家按线上数据先收敛为纯数字校验
  anneng: /^\d{8,30}$/,
  yimidida: /^\d{8,30}$/,
  danniao: /^\d{8,30}$/
};
var CODE_ALIAS_MAP = buildAliasMap(CODE_ALIAS_GROUPS);
var NAME_ALIAS_MAP = buildAliasMap(NAME_ALIAS_GROUPS);
function buildAliasMap(groups) {
  return Object.keys(groups).reduce(function (result, key) {
    groups[key].forEach(function (alias) {
      result[normalizeAlias(alias)] = key;
    });
    return result;
  }, {});
}
function normalizeAlias(value) {
  return String(value || '').trim().toLowerCase();
}
function hasDigit(value) {
  return /\d/.test(value);
}
function resolveRuleKey(deliveryCode, deliveryName) {
  var normalizedCode = normalizeAlias(deliveryCode);
  if (normalizedCode && CODE_ALIAS_MAP[normalizedCode]) {
    return CODE_ALIAS_MAP[normalizedCode];
  }
  var normalizedName = normalizeAlias(deliveryName);
  if (normalizedName && NAME_ALIAS_MAP[normalizedName]) {
    return NAME_ALIAS_MAP[normalizedName];
  }
  return '';
}
function resolveDisplayCompanyName(deliveryName, ruleKey) {
  var normalizedName = String(deliveryName || '').trim();
  if (normalizedName) {
    return normalizedName;
  }
  var aliasNames = NAME_ALIAS_GROUPS[ruleKey] || [];
  return aliasNames[0] || '当前';
}
function normalizeLogisticsTrackingNo(value) {
  if (typeof value !== 'string') {
    return value;
  }
  // 自动去除首尾空格并转大写，和页面输入行为保持一致
  return value.trim().toUpperCase();
}
function isBaseLogisticsTrackingNoValid(value) {
  if (typeof value !== 'string' || !value) {
    return false;
  }
  if (!BASE_TRACKING_NO_PATTERN.test(value)) {
    return false;
  }
  return hasDigit(value);
}
function validateLogisticsTrackingNo() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    transportNo = _ref.transportNo,
    deliveryCode = _ref.deliveryCode,
    deliveryName = _ref.deliveryName;
  var normalizedTransportNo = normalizeLogisticsTrackingNo(transportNo);
  if (!isBaseLogisticsTrackingNoValid(normalizedTransportNo)) {
    return {
      valid: false,
      reason: 'base',
      message: LOGISTICS_TRACKING_NO_ERROR_MESSAGE,
      normalizedTransportNo: normalizedTransportNo
    };
  }

  // 命中物流公司时按公司规则进一步校验，未命中时仅使用通用规则
  var ruleKey = resolveRuleKey(deliveryCode, deliveryName);
  if (!ruleKey || !COMPANY_RULES[ruleKey]) {
    return {
      valid: true,
      reason: '',
      message: '',
      normalizedTransportNo: normalizedTransportNo
    };
  }
  var isCompanyRuleValid = COMPANY_RULES[ruleKey].test(normalizedTransportNo);
  if (!isCompanyRuleValid) {
    var companyName = resolveDisplayCompanyName(deliveryName, ruleKey);
    return {
      valid: false,
      reason: 'company',
      message: "\u4E0D\u7B26\u5408".concat(companyName, "\u7269\u6D41\u5355\u53F7\u89C4\u5219"),
      normalizedTransportNo: normalizedTransportNo,
      companyName: companyName,
      ruleKey: ruleKey
    };
  }
  return {
    valid: true,
    reason: '',
    message: '',
    normalizedTransportNo: normalizedTransportNo,
    ruleKey: ruleKey
  };
}
function isLogisticsTrackingNoValid() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    transportNo = _ref2.transportNo,
    deliveryCode = _ref2.deliveryCode,
    deliveryName = _ref2.deliveryName;
  return validateLogisticsTrackingNo({
    transportNo: transportNo,
    deliveryCode: deliveryCode,
    deliveryName: deliveryName
  }).valid;
}